export const productQuantity = (sum, currentItem) => sum + currentItem.qty
export const totalPrice = (sum, currentItem) => sum + currentItem.price * currentItem.qty
export const totalMRP = (sum, currentItem) => sum + currentItem.price * currentItem.qty








